/**
 * Tax Classification values used to fill select field in Vendor Applicaton
 */

export const DomesticTaxClassifications = [
  { text: 'Individual/Sole Proprietor', value: 'Individual/Sole Proprietor' },
  { text: 'C Corporation', value: 'C Corporation' },
  { text: 'S Corporation', value: 'S Corporation' },
  { text: 'Partnership', value: 'Partnership' },
  { text: 'Trust/Estate', value: 'Trust/Estate' },
  { text: 'LLC: C Corporation', value: 'LLC: C Corporation' },
  { text: 'LLC: S Corporation', value: 'LLC: S Corporation' },
  { text: 'LLC: Partnership', value: 'LLC: Partnership' },
  { text: 'Other', value: 'Other' },
];

export const InternationalTaxClassifications = [
  { text: 'International', value: 'International' },
];

const TaxClassifications = [
  ...DomesticTaxClassifications,
  ...InternationalTaxClassifications,
];

export const VendorTaxClassifications = [
  { text: 'Individual/Sole Proprietor', value: 'Individual/Sole Proprietor' },
  { text: 'C Corporation', value: 'C Corporation' },
  { text: 'S Corporation', value: 'S Corporation' },
  { text: 'Partnership', value: 'Partnership' },
  { text: 'Trust/Estate', value: 'Trust/Estate' },
  { text: 'LLC: C Corporation', value: 'LLC: C Corporation' },
  { text: 'LLC: S Corporation', value: 'LLC: S Corporation' },
  { text: 'LLC: Partnership', value: 'LLC: Partnership' },
  { text: 'International', value: 'International' },
  { text: 'Other', value: 'Other' },
];

export default TaxClassifications;
